import { createContext } from 'react';
import type { CustomControlData, IProcessActivity } from '@common/interfaces';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';

export type ProcessActivityReadContextValue<Data = CustomControlData> = Readonly<{
    processActivity: Omit<IProcessActivity<Data>, 'readSections'>;
    // Can be different from readSections in processActivity, because they may be transformed in `ProcessActivityRead`
    readSections: IProcessActivityReadSection[];
}>;

// `any` is necessary here due to the generic `Data` for ProcessActivityReadContextValue
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProcessActivityReadContext = createContext<ProcessActivityReadContextValue<any> | null>(null);
